<template>
  <div id="home" class="pa-4">
    <v-container fluid>
      <v-alert prominent type="error" v-if="errored">
        <v-row align="center">
          <v-col class="grow">
            <div class="title">Error!</div>
            <div>
              서버 오류가 발생했습니다.
            </div>
          </v-col>
          <v-col class="shrink">
            <v-btn @click="getVideos">Take action</v-btn>
          </v-col>
        </v-row>
      </v-alert>

      <main v-else>
        <!-- 라이브 -->
        <!-- <h3 v-if="lives.length !== 0" class="headline font-weight-medium">라이브</h3> -->
        <v-row v-if="lives.length !== 0">
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="(live, i) in loading ? 12 : lives"
            :key="i"
            class="mx-xs-auto"
          >
            <v-skeleton-loader type="card-avatar" :loading="liveLoading">
              <live-card
                :card="{ maxWidth: 350 }"
                :live="live"
              ></live-card>
            </v-skeleton-loader>
          </v-col>
          <v-col class="text-center" v-if="lives.length === 0 && !liveLoading">
            <v-alert dense prominent outlined type="success">
              <v-row align="center">
                <v-col class="grow">
                  <div>
                    라이브가 없습니다.
                  </div>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <infinite-loading @infinite="getLives">
              <div slot="spinner">
                <v-progress-circular
                  indeterminate
                  color="red"
                ></v-progress-circular>
              </div>
              <div slot="no-results"></div>
              <span slot="no-more"></span>
              <div slot="error" slot-scope="{ trigger }">
                <v-alert prominent type="error">
                  <v-row align="center">
                    <v-col class="grow">
                      <div class="title">Error!</div>
                      <div>
                        서버 오류가 발생했습니다.
                      </div>
                    </v-col>
                    <v-col class="shrink">
                      <v-btn @click="trigger">Take action</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </infinite-loading>
          </v-col>
        </v-row>


        <!-- 영상 -->
        <!-- <h3 class="headline font-weight-medium">영상</h3> -->
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="(video, i) in loading ? 12 : videos"
            :key="i"
            class="mx-xs-auto"
          >
            <v-skeleton-loader type="card-avatar" :loading="loading">
              <video-card
                :card="{ maxWidth: 350 }"
                :video="video"
                :channel="video.userId"
              ></video-card>
            </v-skeleton-loader>
          </v-col>
          <v-col class="text-center" v-if="videos.length === 0 && !loading">
            <v-alert dense prominent outlined type="success">
              <v-row align="center">
                <v-col class="grow">
                  <div>
                    업로드 된 영상이 없습니다.
                  </div>
                </v-col>
                <v-col class="shrink">
                  <v-btn v-if="$store.getters.isAuthenticated" @click="toUpload" color="success">업로드 하러 가기</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <infinite-loading @infinite="getVideos">
              <div slot="spinner">
                <v-progress-circular
                  indeterminate
                  color="red"
                ></v-progress-circular>
              </div>
              <div slot="no-results"></div>
              <span slot="no-more"></span>
              <div slot="error" slot-scope="{ trigger }">
                <v-alert prominent type="error">
                  <v-row align="center">
                    <v-col class="grow">
                      <div class="title">Error!</div>
                      <div>
                        서버 오류가 발생했습니다.
                      </div>
                    </v-col>
                    <v-col class="shrink">
                      <v-btn @click="trigger">Take action</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </infinite-loading>
          </v-col>
        </v-row>
      </main>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'

import LiveCard from '@/components/LiveCard'
import VideoCard from '@/components/VideoCard'
import VideoService from '@/services/VideoService'

export default {
  name: 'Home',
  data: () => ({
    loading: false,
    loaded: false,
    errored: false,
    videos: [],
    // live
    liveLoading: false,
    liveLoaded: false,
    liveErrored: false,
    lives: [],
    page: 1
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    signOut() {
      this.$store.dispatch('signOut')
      this.$router.push('/signin')
    },
    async getLives($state) {
      // $state.complete()
      if (!this.loaded) {
        this.liveLoading = true
      }

      const lives = await VideoService.getStreams("stream", { limit: 0, status: 'live' })
        .catch((err) => {
          console.log(err)
          this.liveErrored = true
        })
        .finally(() => (this.liveLoading = false));

      // if (typeof lives === 'undefined') return
      // // // console.log(videos)
      // // // this.lives = lives.data.data;

      if (lives.data.data.length) {
        this.lives.push(...lives.data.data)
        $state.loaded()
        this.liveLoaded = true
      } 
      $state.complete()
    },
    async getVideos($state) {
      if (!this.loaded) {
        this.loading = true
      }

      const videos = await VideoService.getAll('public', { page: this.page })
        .catch((err) => {
          console.log(err)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
        })

      if (typeof videos === 'undefined') return

      if (videos.data.data.length) {
        this.page += 1
        this.videos.push(...videos.data.data)
        $state.loaded()
        this.loaded = true
      } else {
        $state.complete()
      }
    },
    dateFormatter(date) {
      return moment(date).fromNow()
    },
    toUpload () {
      this.$router.push('/studio')
    },
  },
  mounted() {
    // if (!this.isAuthenticated) this.$router.push('/signin')
  },
  components: {
    LiveCard,
    VideoCard,
    InfiniteLoading
  }
}
</script>

<style lang="scss">
.card {
  background: #f9f9f9 !important;
}
</style>
